@if (variant() === 'default') {
  <!-- Default variant -->
  <div class="criteria-selector">
    <!-- Header with icon and title -->
    <div class="criteria-selector__header">
      <!-- Icon -->
      @if (icon()) {
        @if (isIconUrl(icon())) {
          <img [src]="icon()" alt="" class="criteria-selector__icon" />
        } @else {
          <mat-icon class="criteria-selector__icon">{{ icon() }}</mat-icon>
        }
      }
      <!-- Title -->
      <p class="criteria-selector__title">{{ title() | translateLang }}</p>
    </div>

    <!-- Radio items -->
    <div class="criteria-selector__items">
      @for (item of internalItems(); track item.id) {
        <label class="criteria-selector__item" [attr.data-item-id]="item.id">
          <!-- Radio -->
          <input
            type="radio"
            class="criteria-selector__radio"
            [name]="title()"
            [checked]="item.selected"
            (change)="toggleItem(item)"
          />
          <!-- Label -->
          <span class="criteria-selector__label">{{ item.label | translateLang }}</span>
        </label>
      }
    </div>
  </div>
} @else {
  <!-- Dropdown variant -->
  <div class="criteria-selector criteria-selector--dropdown">
    <!-- Main title (optional) -->
    @if (showMainTitle() && title()) {
      <div class="criteria-selector__header">
        @if (icon()) {
          @if (isIconUrl(icon())) {
            <img [src]="icon()" alt="" class="criteria-selector__icon" />
          } @else {
            <mat-icon class="criteria-selector__icon">{{ icon() }}</mat-icon>
          }
        }
        <p class="criteria-selector__title">{{ title() | translateLang }}</p>
      </div>
    }

    <!-- Dropdown header -->
    <button
      class="criteria-selector__dropdown-header"
      (click)="toggleDropdown()"
      type="button"
    >
      <div class="criteria-selector__dropdown-title-wrapper">
        <p class="criteria-selector__dropdown-title">
          <span class="criteria-selector__dropdown-title-text">{{ dropdownTitle() || title() | translateLang }}</span>
          @if (selectedItems().length > 0) {
            <span class="criteria-selector__dropdown-count">({{ selectedItems().length }} selected)</span>
          }
        </p>
        <img
          src="/assets/images/icons/collapsible-icon.svg"
          alt=""
          class="criteria-selector__dropdown-icon"
          [class.criteria-selector__dropdown-icon--expanded]="isExpanded()"
        />
      </div>
    </button>

    <!-- Dropdown content (collapsible) -->
    @if (isExpanded()) {
      <div class="criteria-selector__dropdown-content">
        <!-- Search input -->
        <div class="criteria-selector__search">
          <input
            type="text"
            class="criteria-selector__search-input"
            [placeholder]="'Type to filter...' | translateLang"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange($event)"
          />
        </div>

        <!-- Scrollable checkbox items -->
        <div class="criteria-selector__dropdown-items">
          @for (item of filteredItems(); track item.id) {
            <label class="criteria-selector__item" [attr.data-item-id]="item.id">
              <!-- Checkbox -->
              <input
                type="checkbox"
                class="criteria-selector__checkbox"
                [checked]="item.selected"
                (change)="toggleItem(item)"
              />
              <span class="criteria-selector__checkbox-visual"></span>
              <!-- Label -->
              <span class="criteria-selector__label">{{ item.label | translateLang }}</span>
            </label>
          } @empty {
            <div class="criteria-selector__no-results">
              <p>{{ 'No results found' | translateLang }}</p>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
